import requests from "../agent";

const Usuario = {
  getAll: () => requests.get("/Usuario/GetUsuarios"),
  getAllByFilter: (data) => requests.post("Usuario/GetUSuariosFiltro", data),
  activeOrInactive: (id, idEstatus) => requests.patch(`/Usuario/ActivarDesactivarUsuario/${id}/${idEstatus}`),
  validarDatosUsuario: (idUsuario, data) => requests.post(`/Usuario/ValidarDatosUsuario/${idUsuario ? '?idUsuario=' + idUsuario : ''}`, data),
  create: (data) => requests.post("/Usuario/CreateUsuario", data),
  update: (id, data) => requests.put(`/Usuario/UpdateUsuario/${id}`, data),
  delete: (id) => requests.delete(`/Usuario/DeleteUsuario/${id}`),
  getInformacionUsuario: () => requests.get(`/Usuario/GetInformacionUsuario`),
  updatePasswordUser: (data) => requests.patch(`/Usuario/UpdatePasswordUser`, data),
  getAlertasUsuario: () => requests.get(`/Usuario/GetAlertasUsuario`),
  consultarArchivoUsuario: (idEstatus) => requests.getFileBlob(`/Usuario/ConsultarArchivoUsuario/${idEstatus}`, null),
  updatePerfil: (idUsuario, idPerfil) => requests.patch(`/Usuario/UpdatePerfil/${idUsuario}/${idPerfil}`),
};

export default Usuario;
